import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { RequestedSource } from '../../enums/DocumentStatus.js';
import { ALPHA_NUMERIC_WITH_UNDERSCORE_DASH } from '../../utils/regex.js';
export class CaseDetails extends BaseMessage {
    documentTypeId;
    documentType;
    journeyId;
    requestedSource;
    ocisEvidenceTypeCode;
    ocisEvidencePurposeCode;
    journeyDocumentStatus;
    documentId;
    document;
    caseId;
    processCode;
    caseReferenceNo;
    caseStatus;
    casePartyID;
    externalSystemId;
    uploadSequenceNo;
    evidenceTypeCode;
    documentCode;
    tmpSysFileRefNum;
    fileName;
    fileSize;
    contentType;
    status;
    fileComments;
    createdBy;
    docUploadCreatedDate;
    docUploadUpdateDate;
    previewCount;
    srcSessionId;
    idDocNumber;
    documentIssuingCountry;
    isBranchScanned;
}
__decorate([
    Field.string({
        description: 'Document Type Id',
        required: false,
        pattern: ALPHA_NUMERIC_WITH_UNDERSCORE_DASH,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "documentTypeId", void 0);
__decorate([
    Field.string({
        description: 'Document Type',
        required: true,
        minLength: 1,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "documentType", void 0);
__decorate([
    Field.string({
        description: 'journeyId id',
        required: true,
        minLength: 1,
        pattern: ALPHA_NUMERIC_WITH_UNDERSCORE_DASH,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "journeyId", void 0);
__decorate([
    Field.enum({
        enum: RequestedSource,
        description: 'requestedSource',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "requestedSource", void 0);
__decorate([
    Field.string({
        description: 'Ocis evidence type code.',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "ocisEvidenceTypeCode", void 0);
__decorate([
    Field.string({
        description: 'ocisEvidencePurposeCode',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "ocisEvidencePurposeCode", void 0);
__decorate([
    Field.string({
        description: 'journeyDocumentStatus',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "journeyDocumentStatus", void 0);
__decorate([
    Field.string({
        description: 'documentId',
        required: false,
        pattern: ALPHA_NUMERIC_WITH_UNDERSCORE_DASH,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "documentId", void 0);
__decorate([
    Field.string({
        description: 'document',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "document", void 0);
__decorate([
    Field.number({
        description: 'caseId',
        numberType: 'number',
        required: false,
    }),
    __metadata("design:type", Number)
], CaseDetails.prototype, "caseId", void 0);
__decorate([
    Field.string({
        description: 'Process Code',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "processCode", void 0);
__decorate([
    Field.string({
        description: 'Case reference number',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "caseReferenceNo", void 0);
__decorate([
    Field.string({
        description: 'Case Status',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "caseStatus", void 0);
__decorate([
    Field.number({
        description: 'casePartyID',
        required: false,
        numberType: 'number',
    }),
    __metadata("design:type", Number)
], CaseDetails.prototype, "casePartyID", void 0);
__decorate([
    Field.number({
        description: 'externalSystemId',
        required: false,
        numberType: 'number',
    }),
    __metadata("design:type", Number)
], CaseDetails.prototype, "externalSystemId", void 0);
__decorate([
    Field.number({
        description: 'externalSystemId',
        required: false,
        numberType: 'number',
    }),
    __metadata("design:type", Number)
], CaseDetails.prototype, "uploadSequenceNo", void 0);
__decorate([
    Field.string({
        description: 'evidenceTypeCode',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "evidenceTypeCode", void 0);
__decorate([
    Field.string({
        description: 'documentCode',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "documentCode", void 0);
__decorate([
    Field.string({
        description: 'tmpSysFileRefNum',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "tmpSysFileRefNum", void 0);
__decorate([
    Field.string({
        description: 'fileName',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "fileName", void 0);
__decorate([
    Field.number({
        description: 'fileSize',
        required: false,
        numberType: 'number',
    }),
    __metadata("design:type", Number)
], CaseDetails.prototype, "fileSize", void 0);
__decorate([
    Field.string({
        description: 'contentType',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "contentType", void 0);
__decorate([
    Field.string({
        description: 'status',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "status", void 0);
__decorate([
    Field.string({
        description: 'fileComments',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "fileComments", void 0);
__decorate([
    Field.string({
        description: 'createdBy',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "createdBy", void 0);
__decorate([
    Field.string({
        description: 'Document Type',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "docUploadCreatedDate", void 0);
__decorate([
    Field.string({
        description: 'docUploadUpdateDate',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "docUploadUpdateDate", void 0);
__decorate([
    Field.string({
        description: 'previewCount',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "previewCount", void 0);
__decorate([
    Field.string({
        description: 'srcSessionId',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "srcSessionId", void 0);
__decorate([
    Field.string({
        description: 'idDocNumber',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "idDocNumber", void 0);
__decorate([
    Field.string({
        description: 'documentIssuingCountry',
        required: false,
    }),
    __metadata("design:type", String)
], CaseDetails.prototype, "documentIssuingCountry", void 0);
__decorate([
    Field.boolean({
        description: 'Is document scanned at branch',
        required: false,
    }),
    __metadata("design:type", Boolean)
], CaseDetails.prototype, "isBranchScanned", void 0);
//# sourceMappingURL=CaseDetails.js.map